import { AxiosError } from 'axios';
import apiClient from 'utils/api-client';

export const get = async (
  onSuccess?: (res: GetSelf) => void,
  onFailed?: (error: AxiosError) => void
) => {
  await apiClient
    .get('/users/self')
    .then(res => {
      onSuccess && onSuccess(res.data);
    })
    .catch(error => {
      onFailed && onFailed(error);
    });
};

// export interface GetSelfParams {}

export interface GetSelf {
  email: string;
  company_id: string;
  location_ids: string[];
  has_auth_for_multi_viewer_service: boolean;
  has_auth_for_blurred_video_service: boolean;
  has_auth_for_shelf_picture_report_service: boolean;
  has_auth_for_event_record_service: boolean;
  has_auth_for_time_lapse_service: boolean;
  has_auth_for_sd_record_viewer_service: boolean;
}
